import 'slick-carousel';
import './related-products-carousel';
import { galleryOptions } from './fancybox-options';
import Swiper from 'swiper';
import { Navigation, Thumbs } from 'swiper/modules';

var productInnerThumbs = new Swiper(".product-inner-thumbs", {
    spaceBetween: 0,
    slidesPerView: 4,
    // centeredSlides: true,
    // freeMode: true,
    watchSlidesProgress: true,
    breakpoints: {
        1200: {
            direction: 'vertical',
        },
    }
});

var productInnerSlider = new Swiper(".product-inner-slider", {
    modules: [Navigation, Thumbs],
    // loop: true,
    spaceBetween: 10,
    slidesPerView: 1,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    thumbs: {
        swiper: productInnerThumbs,
    },
});

$('[data-fancybox="product"]').fancybox(galleryOptions);
$('[data-fancybox]').fancybox(galleryOptions);

// $('.product-gallery-thumbs').slick({
//     infinite: true,
//     slidesToShow: 5,
//     slidesToScroll: 1,
//     vertical: true,
//     verticalSwiping: true,
//     arrows: false
// });